import { HTMLElementEventType } from "../../../common/components/misc.enums";
const EMAIL_SESSION_STORAGE_KEY = "email";
export const enableEmailRestoring = (elementId, emailInput) => {
    restoreEmailValue(emailInput);
    storeEmailValueOnClick(elementId, emailInput);
};
const storeEmailValueOnClick = (elementId, emailInput) => {
    const clickElement = document.getElementById(elementId);
    if (clickElement === null) {
        return;
    }
    clickElement.addEventListener(HTMLElementEventType.Click, () => {
        const emailValue = emailInput.value;
        if (emailValue) {
            storeEmailValue(emailValue);
        }
    });
};
const storeEmailValue = (value) => {
    sessionStorage.setItem(EMAIL_SESSION_STORAGE_KEY, value);
};
const restoreEmailValue = (input) => {
    const storedValue = sessionStorage.getItem(EMAIL_SESSION_STORAGE_KEY);
    if (storedValue === null) {
        return;
    }
    input.value = storedValue;
    sessionStorage.removeItem(EMAIL_SESSION_STORAGE_KEY);
};
